/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CopyIcon24Regular = forwardRef('CopyIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 1.25A3.75 3.75 0 0 0 3.25 5v12A3.75 3.75 0 0 0 7 20.75h8A3.75 3.75 0 0 0 18.75 17V5A3.75 3.75 0 0 0 15 1.25H7ZM4.75 5A2.25 2.25 0 0 1 7 2.75h8A2.25 2.25 0 0 1 17.25 5v12A2.25 2.25 0 0 1 15 19.25H7A2.25 2.25 0 0 1 4.75 17V5Z" }),
        React.createElement("path", { d: "M21.75 9a.75.75 0 0 0-1.5 0v8.5a4.75 4.75 0 0 1-4.75 4.75H9a.75.75 0 0 0 0 1.5h6.5a6.25 6.25 0 0 0 6.25-6.25V9Z" })));
});
